import React from 'react';
import { Link, withRouter } from "react-router-dom"
import { getPolicyUser } from '../../../helpers/api_helper';

const Columns = ( addUpd, destroy ) => {
		const policy = getPolicyUser();
		let columns = [
			{
				id: 'name',
				name: 'Nombre',
				selector: row => row.name,
				sortable: true,
				wrap: true,
				width:'40%'
			},
			{
				id: 'order',
				name: 'Orden',
				selector: row => row.order,
				sortable: true,
				wrap: true,
				width:'20%'
			},
			
			{
				id: 'actions',
				name: 'Acciones',
				width:'40%',
				button: true,
				cell: row => (
					<div className="d-flex justify-content-between">
						
						<div className="p-2">
                            <button className="btn btn-primary btn-sm" title='Editar usuario' onClick={() => addUpd(row)}><i className="fas fa-edit"></i></button>
                        </div>
                        
                        <div className="p-2">
                            <button className="btn btn-danger btn-sm" title='Eliminar usuario' onClick={() => destroy(row.id)}><i className="fas fa-trash"></i></button>
                        </div>
                    	
					</div>
				),
			}
		];
	return columns;
}

export default Columns;